import { Tooltip } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";

interface ColorTagProps {
  color: string;
  label: string;
  disableTruncation?: boolean;
}

const COLOR_MAP: Record<string, string> = {
  blue: "al-text-[#247efe] al-bg-[rgba(36,126,254,0.15)]",
  orange: "al-text-[#ff754c] al-bg-[rgba(255,117,76,0.15)]",
  red: "al-text-[#ee140f] al-bg-[rgba(238,20,15,0.15)]",
  green: "al-text-[#01cd8c] al-bg-[rgba(1,205,140,0.15)]",
  dark_green: "al-text-[#19504d] al-bg-[#d3f8f8]",
  yellow: "al-text-[#783a00] al-bg-[#fff4c3]",
  purple: "al-text-[#392091] al-bg-[#e6ddff]",
};

const getColorStyles = (color: string): string => {
  return COLOR_MAP[color] || color;
};

const ColorTag = ({ color, label, disableTruncation = false }: ColorTagProps) => {
  const shouldTruncate = !disableTruncation && label.length > 20;
  const displayLabel = shouldTruncate ? `${label.slice(0, 18)}...` : label;

  const tagElement = (
    <div
      className={`al-inline-flex al-items-center al-px-[10px] al-py-1 al-text-xs al-font-medium al-rounded-[30px] al-whitespace-nowrap al-text-ellipsis al-m-[2px] al-text-[12px] al-leading-[1.2] ${getColorStyles(color)}`}
    >
      {displayLabel}
    </div>
  );

  if (shouldTruncate) {
    return (
      <Tooltip
        title={
          <Stack direction="column" align="start" gap="xs" justify="center">
            {label}
          </Stack>
        }
      >
        {tagElement}
      </Tooltip>
    );
  }

  return tagElement;
};

export default ColorTag;
